import { render, staticRenderFns } from "./TributeStories.vue?vue&type=template&id=64bc4da4&scoped=true"
import script from "./TributeStories.vue?vue&type=script&lang=js"
export * from "./TributeStories.vue?vue&type=script&lang=js"
import style0 from "./TributeStories.vue?vue&type=style&index=0&id=64bc4da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc4da4",
  null
  
)

export default component.exports